import React from "react";

const Badge = ({ count, classes, innerClasses }) => {
  return (
    <div className={` ${classes ? classes : ""}`}>
      {count > 0 && <div
        className={`bg-[#F95454] text-white text-[10px] rounded-full w-[18px] h-[18px] flex items-center justify-center ${
          innerClasses ? innerClasses : ""
        }`}
      >
        {count > 99?"99+":count}
      </div>}
    </div>
  );
};

export default Badge;
